<div class="vh_center mt-4">
    <div col="12">
        <div style=" margin:0px; " class="vh_center">
            <img class=" " src="assets/img/c_va.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #fcb816;"></div>
            <img class=" " src="assets/img/c_yl.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
            <div style="width:130px; height:5px; background-color: #dadada;"></div>
            <img class=" " src="assets/img/c_ge.png" width="27" height="27" style=" float:left;" />
        </div>
    </div>
</div>
<div class="vh_center mt-2">
    <div col="12">
      <div style=" margin:0px; font-size: 14px; color:#999999; " class="vh_center">
        <div style="width:210px; padding-left: 45px;  background-color: #ffffff;">File Validation</div>
        <div style="width:150px;  padding-left: 15px; background-color: #ffffff;">Quote</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Order details</div>
        <div style="width:150px; padding-left: 0px;  background-color: #ffffff;">Review & Confirm</div>
        <div style="width:150px;   padding-left: 15px;  background-color: #ffffff;">Place order</div>
      </div>
    </div>
</div>
<!-- *ngIf="pageShow.showerrorFreeBomItemsData" -->
<section  class="container-fluid">
  
    <!-- <div class="text-center fa-2x mt-3"><b>{{commonService.commonMainObj.finalBomDataToPurchase?.productTitle}}</b></div> -->
    <div class="text-center fa-2x mt-3"><b>Components Procurement</b></div>
    <!-- <div class="text-center">- by Turnkey Pro</div> -->
    <div class="text-center row m-0">
        <div class="col-4"></div>
        <div class="col-4 p-2 mt-1">
            <div><b>BOM File: <span class="txt_dark_red">{{commonService.commonMainObj.uploadedFile?.name}}</span></b></div>
            <div><b>Quantity: <span class="txt_dark_red">{{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies</span></b></div>
            <div><b>BOM ID: <span class="txt_dark_red">{{commonService.commonMainObj.finalBomDataToPurchase?.bomId}}</span></b></div>
            <!-- <div class="mt-3"><a><b>Download latest version of this online BOM</b></a></div> -->
        </div>
        <div class="col-4"></div>
    </div>
    <div class="col-12 mb-2 text-right">
        <span >
          <!-- <a *ngIf="commonService.commonMainObj.autoUploadFileName" class="text-primary p-4 text_deco_underline cursor-pointer" target="_blank" href="{{apiService.apiMainObj.autoBOMFileDownloadUrl}}{{commonService.commonMainObj.autoUploadFileId}}"><b>Download BOM file</b></a> -->
          <a class="cursor-pointer btn btn-warning fs14" (click)="downloadBom()"><b>Download BOM</b></a>
        </span>
        <!-- href="{{apiService.apiMainObj.scaBOMFileDownloadUrl}}{{commonService.commonMainObj.finalBomDataToPurchase?.bomId}}" -->
    </div>
    
    <div class="pt-3 mb-3">
      <p class="mb-4 fs-14"><i><b>No hidden surprises--</b>{{commonService.commonMainObj.finalBomDataToPurchase?.notesToUser[0].split('No hidden surprises—')[1] }}</i></p>
      <p class="mb-4 fs-14">
          <i><b>For passives only:</b> {{commonService.commonMainObj.finalBomDataToPurchase?.notesToUser[1].split('For passives only:')[1]}}</i>
      </p>
      <p class="mb-4 fs-14">
        <i><b>Restrictions on Consigned components:</b> {{commonService.commonMainObj.finalBomDataToPurchase?.notesToUser[2].split('Restrictions on Consigned components:')[1]}}</i>
      </p>
      <p class="mb-4 fs-14">
        <i><b>Handling charges for consigned components:</b> {{commonService.commonMainObj.finalBomDataToPurchase?.notesToUser[3].split('Handling charges for consigned components:')[1]}}</i>
      </p>
    </div>
    <div class="col-12" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy != null && commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.items.length>0">
        <div class="col-12 p-2 display-flex sierra_purchase_header">
            <div class="col-11"><span class="m-1 text-uppercase">{{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.title}}</span></div>
            <div class="col-1"><span class="bg-dark border-radius cursor-pointer p-1 text-white fs-14" (click)="showHidePurcData()">Show / Hide</span></div>
        </div>
        <div class="col-12 mb-3 justify-content-center" id="budgetaryQuoteTableSec" *ngIf="showPurchaseData">
            <div class="col-sm-12">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <!-- <th align="center" valign="middle"></th> -->
                                <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                                <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <!-- <th style="width: 10%;" align="center" valign="middle">VENDOR PART NUMBER</th> -->
                                <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                                <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                                <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)({{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies)</th>
                                <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                                <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                                <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                                <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                                <!-- <th align="center" valign="middle"></th> -->
                            </tr>
                        </thead>
                        <tbody id="display-tbody-okayTobuy">
                            <tr *ngFor="let lit of commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.items; let in = index">
                                <!-- <td align="center" valign="top"><input type="checkbox" /></td> -->
                                <td align="center" valign="top">{{lit.itemNo}}</td>
                                <td align="center" valign="top">{{lit.mpn}}</td>
                                <!-- <td align="center" valign="top">{{lit.vendorPartNum != "null" ? lit.vendorPartNum:'' }}</td> -->
                                <td align="center" valign="top">{{lit.manufacturerName}}</td>
                                <td align="center" valign="top">{{lit.qtyPerBoard}}</td>
                                <td align="center" valign="top">{{lit.buyQty}}</td>
                                <!-- <td align="center" valign="top"></td> -->
                                <td align="center" valign="top">{{lit.altMpn}}</td>
                                <td align="center" valign="top">{{lit.referenceDesignator}}</td>
                                <td align="center" valign="top"> </td>
                                <td align="center" valign="top">
                                  <select (change)="lineItemChange(lit.selectedAction,lit)" [(ngModel)]="lit.selectedAction">
                                      <option [value]="actions.actionId" [selected]="actions.actionId == lit.selectedAction" *ngFor="let actions of lit.availableActions; let chIndx = index">{{actions.actionName.replace('OKay','Okay')}}</option>
                                      <!-- <option value="DNI">DNI (Do Not Install)</option>
                                      <option value="Customer Will Consign">Customer Will Consign</option>
                                      <option value="Customer Support">Customer Support</option> -->
                                  </select>
                                  <div class="p-2" *ngIf="lit.buttonStatus == 'View History'" >
                                    <button class="bg-gray text-white" (click)="getAssistRequest(resolve_item,lit)">{{lit.buttonStatus}} 
                                    </button>
                                  </div>
                                </td>
                                <!-- <td align="center" valign="top">
                                    <div class="display-flex">
                                        <i class="fa fa-pencil p-1 border m-1 fs14 border-radius cursor-pointer" *ngIf="!showSaveItemEditOpt" (click)="lineItemUpdate('true')" aria-hidden="true"></i>
                                        <i class="fa fa-check p-1 border m-1 fs14 border-radius cursor-pointer clr_green" *ngIf="showSaveItemEditOpt" aria-hidden="true"></i>
                                        <i class="fa fa-times p-1 border m-1 fs14 border-radius cursor-pointer" *ngIf="showSaveItemEditOpt" (click)="lineItemUpdate('false')" aria-hidden="true"></i>
                                        <i class="fa fa-trash p-1 border m-1 fs14 border-radius cursor-pointer" *ngIf="!showSaveItemEditOpt" aria-hidden="true"></i>
                                    </div>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="mb-3" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy != null && commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.items.length>0">
        <div class="row m-0 bg_light_gray">
            <div class="col-2"></div>
            <div class="col-4 text-end">
                <p class="m-0">{{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.description1}} <i class="fa fa-check clr_green fs-5" aria-hidden="true"></i></p>
                <p class="m-0">{{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.description2}} <i class="fa fa-check clr_green fs-5" aria-hidden="true"></i></p>
            </div>
            <div class="col-6">
              <p class="m-0 fs-5 text-end"><b>Component Total</b> <span *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.componentTotalText">{{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.componentTotalText.split('Component Total')[1]}}</span> </p>
              <p class="m-0 fs12 text-end text-danger" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.minChargeText"> {{commonService.commonMainObj.finalBomDataToPurchase?.okayToBuy?.componentTotalModel?.minChargeText}} </p>
                <!-- <p class="m-0 fs-5 text-end"><b>Component Total</b> (for {{commonService.commonMainObj.finalBomDataPrices?.quantity}} boards)<b>: ${{commonService.commonMainObj.finalBomDataPrices?.bomPrice}}</b></p> -->
            </div>
        </div>
        
        <!-- <div class="col-12 p-3 text-center">
            <button type="button" class="btn btn-warning fs14 m-3 w-10 p-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"  (click)="lineItemPopup(new_line_item)"> <b>New Line Item</b>
            </button>
            <button type="button" class="btn btn-warning fs14 m-3 w-10 p-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <b>DNI</b>
            </button>
            <button type="button" class="btn btn-warning fs14 m-3 p-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <b>Customer Will Consign</b>
            </button>
        </div> -->

    </div>
    <div class="col-12 mt-5" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.doNotInstall != null && commonService.commonMainObj.finalBomDataToPurchase?.doNotInstall?.items.length>0">
        <div class="dni_header_table p-1">
            <span class="m-1"><b>{{commonService.commonMainObj.finalBomDataToPurchase?.doNotInstall?.title}}</b></span>
        </div>
        <div class="col-12 justify-content-center" id="budgetaryQuoteTableSec">
            <div class="col-sm-12">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th  style="width: 2%;"align="center" valign="middle">ITEM#</th>
                                <th  style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <!-- <th style="width: 10%;" align="center" valign="middle">VENDOR PART NUMBER</th> -->
                                <th style="width: 8%;"align="center" valign="middle">MANUFACTURER NAME</th>
                                <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                                <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)( {{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies)</th>
                                <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                                <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                                <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                                <th  style="width: 8%;" align="center" valign="middle">ACTION</th>
                                <!-- <th align="center" valign="middle"></th> -->
                            </tr>
                        </thead>
                        <tbody id="display-tbody-dni">
                          <tr *ngFor="let dniObj of commonService.commonMainObj.finalBomDataToPurchase?.doNotInstall?.items; let in = index">
                            <td align="center" valign="top">{{dniObj.itemNo}}</td>
                            <td align="center" valign="top">{{dniObj.mpn}}</td>
                            <!-- <td align="center" valign="top">{{dniObj.vendorPartNum != "null" ? dniObj.vendorPartNum:''}}</td> -->
                            <td align="center" valign="top">{{dniObj.manufacturerName}}</td>
                            <td align="center" valign="top">{{dniObj.qtyPerBoard}}</td>
                            <td align="center" valign="top">{{dniObj.buyQty}}</td>
                            <td align="center" valign="top">{{dniObj.altMpn}}</td>
                            <td align="center" valign="top">{{dniObj.referenceDesignator}}</td>
                            <td align="center" valign="top"><span *ngIf="dniObj.issueName=='Long Lead-time' || dniObj.issueName=='Obsolete Part'">{{dniObj.issueName}}</span> <span *ngIf="dniObj.issueName=='Long Lead-time' || dniObj.issueName=='Obsolete Part'"></span> </td>
                            <td align="center" valign="top">
                              <!-- <select (change)="lineItemChange(dniObj.selectedAction,dniObj)"  [(ngModel)]="dniObj.selectedAction">
                                  <option [value]="actions.actionId" [selected]="actions.actionId == dniObj.selectedAction" *ngFor="let actions of dniObj.availableActions; let chIndx = index">{{actions.actionName.replace('OKay','Okay')}}</option>
                              </select> -->
                              <select (change)="dniLineItemChange(dniObj.selectedAction,dniObj,levelOneIssueModal)"  [(ngModel)]="dniObj.selectedAction">
                                <option [value]="actions.actionId" [selected]="actions.actionId == dniObj.selectedAction" *ngFor="let actions of dniObj.availableActions; let chIndx = index">{{actions.actionName.replace('OKay','Okay')}}</option>
                            </select>
                              <div class="p-2" *ngIf="dniObj.buttonStatus == 'View History'" >
                                <button class="bg-gray text-white" (click)="getAssistRequest(resolve_item,dniObj)">{{dniObj.buttonStatus}} 
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-12 mt-5" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.iWillProvide != null && commonService.commonMainObj.finalBomDataToPurchase?.iWillProvide?.items.length>0">
        <div class="p-1 customer_wil_consign">
            <span class="m-1"><b>CUSTOMER WILL CONSIGN:</b> <span class="fs12">{{commonService.commonMainObj.finalBomDataToPurchase?.iWillProvide?.title.split('I WILL PROVIDE:')[1]}}</span></span>
        </div>
        <div class="col-12 justify-content-center" id="budgetaryQuoteTableSec">
            <div class="col-sm-12">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th style="width: 2%;" align="center" valign="middle">ITEM#</th>
                                <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <!-- <th style="width: 10%;" align="center" valign="middle">VENDOR PART NUMBER</th> -->
                                <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                                <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                                <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)( {{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies)</th>
                                <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                                <th style="width: 15%;"align="center" valign="middle">REFERENCE DESIGNATORS</th>
                                <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                                <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-iprod">
                          <tr *ngFor="let custObj of commonService.commonMainObj.finalBomDataToPurchase?.iWillProvide?.items; let in = index">
                            <td align="center" valign="top">{{custObj.itemNo}}</td>
                            <td align="center" valign="top">{{custObj.mpn}}</td>
                            <!-- <td align="center" valign="top">{{custObj.vendorPartNum != "null" ? custObj.vendorPartNum:''}}</td> -->
                            <td align="center" valign="top">{{custObj.manufacturerName}}</td>
                            <td align="center" valign="top">{{custObj.qtyPerBoard}}</td>
                            <td align="center" valign="top">{{custObj.buyQty}}</td>
                            <td align="center" valign="top">{{custObj.altMpn}}</td>
                            <td align="center" valign="top">{{custObj.referenceDesignator}}</td>
                            <td align="center" valign="top"> </td>
                            <td align="center" valign="top">
                              <select (change)="lineItemChange(custObj.selectedAction,custObj)" [(ngModel)]="custObj.selectedAction">
                                  <option [value]="actions.actionId" [selected]="actions.actionId == custObj.selectedAction" *ngFor="let actions of custObj.availableActions; let chIndx = index">{{actions.actionName.replace('OKay','Okay')}}</option>
                              </select>
                              <div class="p-2" *ngIf="custObj.buttonStatus == 'View History'" >
                                <button class="bg-gray text-white" (click)="getAssistRequest(resolve_item,custObj)">{{custObj.buttonStatus}} 
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-5" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.customerSupport != null && commonService.commonMainObj.finalBomDataToPurchase?.customerSupport?.items.length>0">
        <div class="p-1 customer_service_req">
            <span class="m-1"><b>{{commonService.commonMainObj.finalBomDataToPurchase?.customerSupport?.title}}</b></span>
        </div>
        <div class="col-12 justify-content-center" id="budgetaryQuoteTableSec">
            <div class="col-sm-12">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                          <tr>
                            <th style="width: 2%;"  align="center" valign="middle">ITEM#</th>
                            <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                            <!-- <th style="width: 10%;" align="center" valign="middle">VENDOR PART NUMBER</th> -->
                            <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                            <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                            <th style="width: 9%;" align="center" valign="middle">TOTAL QUANTITY (Including attrition)( {{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies)</th>
                            <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                            <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                            <th style="width: 15%;" align="center" valign="middle">REMARKS</th>
                            <th  style="width: 8%;"  align="center" valign="middle">ACTION</th>
                        </tr>
                        </thead>
                        <tbody id="display-tbody-cs">
                          <tr *ngFor="let custReqObj of commonService.commonMainObj.finalBomDataToPurchase?.customerSupport?.items; let in = index">
                            <td align="center" valign="top">{{custReqObj.itemNo}}</td>
                            <td align="center" valign="top">{{custReqObj.mpn}}</td>
                            <!-- <td align="center" valign="top">{{custReqObj.vendorPartNum != "null" ? custReqObj.vendorPartNum:''}}</td> -->
                            <td align="center" valign="top">{{custReqObj.manufacturerName}}</td>
                            <td align="center" valign="top">{{custReqObj.qtyPerBoard}}</td>
                            <td align="center" valign="top">{{custReqObj.buyQty}}</td>
                            <td align="center" valign="top">{{custReqObj.altMpn}}</td>
                            <td align="center" valign="top">{{custReqObj.referenceDesignator}}</td>
                            <td align="center" valign="top"><span *ngIf="custReqObj.issueName=='Long Lead-time' || custReqObj.issueName=='Obsolete Part'">{{custReqObj.issueName}}</span> <span *ngIf="custReqObj.issueName!='Long Lead-time' || custReqObj.issueName!='Obsolete Part'"> </span> </td>
                            <td align="center" valign="top">
                              <select (change)="lineItemChange(custReqObj.selectedAction,custReqObj)" [(ngModel)]="custReqObj.selectedAction">
                                  <option [value]="actions.actionId" [selected]="actions.actionId == custReqObj.selectedAction" *ngFor="let actions of custReqObj.availableActions; let chIndx = index">{{actions.actionName.replace('OKay','Okay')}}</option>
                              </select>
                              <div class="" *ngIf="custReqObj.buttonStatus">
                                <button class="bg-gray text-white" (click)="getAssistRequest(resolve_item,custReqObj)">
                                  <i class="fa fa-comment fs-6 text-white" aria-hidden="true"></i> {{custReqObj.buttonStatus}} 
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-5" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.issueFound != null && commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.items.length>0">
        <div class="p-1 bg-red-section">
            <span class="m-1"><b> {{commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.title}}</b></span>
        </div>
        <div class="col-12 mb-3 justify-content-center" id="budgetaryQuoteTableSec">
            <div class="col-sm-12">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th style="width: 2%;" align="center" valign="middle">ITEM#</th>
                                <th style="width: 10%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <!-- <th style="width: 10%;" align="center" valign="middle">VENDOR PART NUMBER</th> -->
                                <th style="width: 8%;" align="center" valign="middle">MANUFACTURER NAME</th>
                                <th style="width: 8%;" align="center" valign="middle">QUANTITY PER BOARD</th>
                                <th style="width: 9%;"  align="center" valign="middle">TOTAL QUANTITY (Including attrition)( {{commonService.commonMainObj.finalBomDataToPurchase?.assemblyQty}} Assemblies)</th>
                                <th style="width: 10%;" align="center" valign="middle">ALTERNATE MPN</th>
                                <th style="width: 15%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                                <th style="width: 8%;" align="center" valign="middle">ISSUE</th>
                                <th style="width: 8%;" align="center" valign="middle">ACTION</th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-issues">
                          <tr *ngFor="let issuesObj of commonService.commonMainObj.finalBomDataToPurchase?.issueFound?.items; let in = index">
                            <td align="center" valign="top">{{issuesObj.itemNo}}</td>
                            <td align="center" valign="top">{{issuesObj.mpn}}</td>
                            <!-- <td align="center" valign="top">{{issuesObj.vendorPartNum != "null" ? issuesObj.vendorPartNum:''}}</td> -->
                            <td align="center" valign="top">{{issuesObj.manufacturerName}}</td>
                            <td align="center" valign="top">{{issuesObj.qtyPerBoard}}</td>
                            <td align="center" valign="top">{{issuesObj.buyQty}}</td>
                            <td align="center" valign="top">{{issuesObj.altMpn}}</td>
                            <td align="center" valign="top">{{issuesObj.referenceDesignator}}</td>
                            <td align="center" valign="top">{{issuesObj.issueName}}</td>
                            <td align="center" valign="top">
                              <button class="m-1 bg-orng_light text-white" (click)="resolveLineItem(resolve_item,issuesObj)">Resolve</button>
                              <div class="p-2" *ngIf="issuesObj.buttonStatus">
                                <button class="m-1 bg-gray text-white" (click)="getAssistRequest(resolve_item,issuesObj)">
                                  <i class="fa fa-comment fs-6 text-white" aria-hidden="true"></i> {{issuesObj.buttonStatus}} 
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="col-12 p-4">
        <div class="bg-yellow p-1"></div>
    </div>
    <div class="col-12 p-4">
        <div class="p-1 bg_light_gray">
            <span class="m-1 fs-5"><b>SPECIAL INSTRUCTIONS:</b></span>
        </div>
        <div class="p-2  bg_light_gray">
            <textarea class="form-control" placeholder="Please enter any Special Instructions about your BOM or Assembly here."></textarea>
            <button type="button" class="btn btn-warning fs14 mt-2" data-mdb-toggle="button" autocomplete="off" aria-pressed="true"> <b>ADD</b>
            </button>
        </div>
    </div> -->
    
    <div class="col-12 text-center" *ngIf="commonService.commonMainObj.finalBomDataToPurchase?.recommendations && commonService.commonMainObj.finalBomDataToPurchase?.recommendations?.length>0">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5  m-3" data-mdb-toggle="button" autocomplete="off" id="sierraSugAlt" aria-pressed="true" (click)="sierraRecommandedAlts(alternateMpnModal)"> <b>Sierra Recommended Alternates</b></button>
      <div class="fs12 fw-semibold text-success">(Why? These parts are immediately available and have equal or better tolerance than your specified parts)</div>
    </div>
    <div class="col-12 text-center">
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="commonService.goBack()"> <b>Cancel</b>
      </button>
      <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" data-mdb-toggle="button" autocomplete="off" aria-pressed="true" (click)="proceedBomAssembly()"> <b>Proceed</b>
      </button>
    </div>
    <!-- <div class="col-12 p-4 text-center">
        <p class="clr_green mb-3"> <b>You can get an instant Turnkey Quote after BOM issues are resolved!</b></p>
        <p class="m-0">we can produce fully assembly boards in five days.</p>
        <p class="m-0">Almost there! Get a full Turnkey Quote on the next page.</p>
    </div> -->

    <ng-template #resolve_item let-modal class="address-book-modal">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title"><span *ngIf="conversionData.title">{{conversionData.title}}</span> <span *ngIf="resolveData">Resolve Issue</span></h4>
          <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="modal-crose">×</span>
          </button>
        </div>
        <div class="modal-body" *ngIf="resolveData">
            <div class="row text-center mb-4">
                <div class="fw-bold">BOM ID: <span class="text-danger">{{commonService.commonMainObj.finalBomDataToPurchase?.bomId}}</span></div>
            </div>
            <div class="row mb-3 justify-content-center" id="budgetaryQuoteTableSec">
              <div class="col-sm-3"></div>
              <div class="col-sm-6">
                  <div class="table-responsive" id="budgetaryQuoteTable">
                      <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                          <thead>
                              <tr>
                                  <th align="center" valign="middle">ITEM#</th>
                                  <th align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                  <!-- <th align="center" valign="middle">DETAILED DESCRIPTION</th> -->
                              </tr>
                          </thead>
                          <tbody id="display-tbody-resol">
                              <tr>
                                  <td align="center" valign="top">{{resolveData.itemNumber}}</td>
                                  <td align="center" valign="top">{{resolveData.mpn}}</td>
                                  <!-- <td align="center" valign="top">{{resolveData.partDescription}}</td> -->
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
              <div class="col-sm-3"></div>
            </div>
            <div class="mb-3">
                <div class="fw-bold">Issue: {{resolveData?.issueName}}</div>
                <p class="m-0 fs14"><i>{{resolveData?.issueResolutionText}}</i></p>
                <!-- <p class="m-0 fs14"><i>Please check whether you have the right MPN. If there is a typo, you can edit the MPN and system will re-run.</i></p>
                <p class="m-0 fs14"><i>Or you may dicide to DNI this part or you may supply it as consigned.</i></p>
                <p class="m-0 fs14"><i>Or you can ask for assistance from our Component Engineering team.</i></p> -->
            </div>
            <div class="mb-3">
              <div class="fw-bold">Choose Resolution:</div>
              <div *ngIf="resolveData.directMPNSubstitute">
                <div class="fs12" *ngIf="resolveData.directMPNSubstitute && resolveData.directMPNSubstitute[0]?.substituteMPNList.length>0">{{resolveData.directMPNSubstitute[0]?.resolutionName}}</div>
                <div *ngIf="resolveData.directMPNSubstitute[0]?.substituteMPNList">
                  <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th align="center" valign="middle">Select</th>
                                <th align="center" valign="middle">MPN</th>
                                <th align="center" valign="middle">Part Number</th>
                                <th align="center" valign="middle">Quantity in Stock</th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-substitute">
                            <tr *ngFor="let mpnSubStituteObj of resolveData.directMPNSubstitute[0].substituteMPNList">
                              <td align="center" valign="top"><input type="radio" name="resolvutionCheck" value="resolveData.directMPNSubstitute[0].resolutionId" (click)="selectResol(mpnSubStituteObj,resolveData.directMPNSubstitute[0].resolutionId)"/></td>
                              <td align="center" valign="top">{{mpnSubStituteObj.mpn}}</td>
                              <td align="center" valign="top">{{mpnSubStituteObj.digikeyPartNumber}}</td>
                              <td align="center" valign="top">{{mpnSubStituteObj.quantityAvailable}}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
                <div class="fw-bold fs-14" *ngIf="resolveData.directMPNSubstitute">OR</div>
              </div>
              <div class="p-2">
                  <div *ngFor="let resolObj of resolveData?.issueResolutionList"><span><input type="radio" name="resolvutionCheck" value="resolObj.resolutionId" (click)="selectResol('',resolObj.resolutionId)"/> {{resolObj.resolutionName}} <span *ngIf="resolObj.resolutionId == 11">({{resolveData.altMpn}}) ($ {{resolveData.lotPrice}})</span></span></div>
                  <!-- <div><span><input type="radio" name="asnckjn" value="2" /> Customer will supply</span></div>
                  <div><span><input type="radio" name="asnckjn" value="3" /> Ask sierra to recommand/find alternate part (Component Engineering Help)</span></div>
                  <div><span><input type="radio" name="asnckjn" value="4" /> Fix Line Item</span></div> -->
              </div>
            </div>
            <div class="mb-3 justify-content-center" *ngIf="selectedResolId == 3">
              <div class="col-sm-12">
                <div class="table-responsive" id="resolve_issue_edit">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <th align="center" valign="middle">QUANTITY</th>
                                <th align="center" valign="middle">REFERENCE DESIGNATORS</th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-updateMpn">
                            <tr>
                                <td align="center" valign="top">
                                  <input class="form-control" type="text" value="{{resolveDataDuplicate.mpn}}" [(ngModel)]="resolveDataDuplicate.mpn" required/>
                                </td>
                                <td align="center" valign="top">
                                  <input class="form-control" type="text" value="{{resolveDataDuplicate.qty}}" [(ngModel)]="resolveDataDuplicate.qty" required/>
                                </td>
                                <td align="center" valign="top">
                                  <input class="form-control" type="text" value="{{resolveDataDuplicate.refdesc}}" [(ngModel)]="resolveDataDuplicate.refdesc" required/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="level1Errors.length > 0">
              <div *ngFor="let errorCheck of level1Errors let indx = index" class="text-danger fs14">{{indx +1}}. {{errorCheck.split('Invalid - ')[1]}}</div>
            </div>
          </div>
        </div>
        <div class="modal-body" *ngIf="conversionData">
          <div class="row text-center mb-4">
              <div class="fw-bold">BOM ID: <span class="text-danger">{{commonService.commonMainObj.finalBomDataToPurchase?.bomId}}</span></div>
          </div>
          <div class="row mb-3 justify-content-center" id="budgetaryQuoteTableSec">
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
                <div class="table-responsive" id="budgetaryQuoteTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th align="center" valign="middle">ITEM#</th>
                                <th align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <!-- <th align="center" valign="middle">DETAILED DESCRIPTION</th> -->
                            </tr>
                        </thead>
                        <tbody id="display-tbody-newMpn">
                            <tr>
                                <td align="center" valign="top">{{selectedMpnData.itemNo}}</td>
                                <td align="center" valign="top">{{selectedMpnData.mpn}}</td>
                                <!-- <td align="center" valign="top">{{selectedMpnData.partDescription}}</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-sm-3"></div>
          </div>
          <div class="mb-3">
            <div class="row border-radius p-3" style="background: wheat;">
              <div class="text-center"><b>{{conversionData.title}}</b></div>
              <p class="text-center fs-14">{{conversionData.msgAboveChatBOX}}.</p>
              <div class="row" [hidden]="!conversionData.conversations" *ngFor="let conObj of conversionData.conversations">
                <div class="col-10">
                  <p class="p-1 text-left border border-white">{{conObj.sbci_post_notes}} </p>
                </div>
                <div class="col-2 fs12">
                  <div><p class="m-0">{{conObj.createdBy}} </p></div>
                  <div><p class="m-0">{{conObj.createdOn}} </p></div>
                </div>
              </div>
              <div class="fs12 text-center pe-lg-5" *ngIf="assistSubmitMsg">{{conversionData.acknowledgement}}</div>
              <!-- <div class="fs-14 text-center" *ngIf="assistSubmitMsg">Component Engineers typically respond within 30 minutes on weekdays between 8am - 8 pm Pacific.</div> -->
              <div class="row mt-3" *ngIf="selectedMpnData.buttonStatus != 'View History'">
                <div class="col-10">
                  <textarea class="form-control" [(ngModel)]="postConversation" placeholder="Need a part recommandation or have any other quetions for our component engineer? Post here"></textarea>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3" (click)="subAssistRequest(selectedMpnData,postConversation)">Submit</button>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="modal-footer text-center" style="display: block;">
        <!-- [disabled]="!selectedResolId" OFP-613 -->
        <button type="button" class="btn btn-custom btn-warning btn_blue_custom px-xxl-5 m-3" *ngIf="resolveData" (click)="proceedWithResol()"><b>Proceed</b></button>
        <button type="button" class="btn btn-custom btn-warning px-xxl-5 m-3 btn-danger btn-red-custom" (click)="modal.close('cancel click')"  *ngIf="conversionData"><b>Close</b></button>
      </div>
    </ng-template>

    <ng-template #alternateMpnModal let-modal class="address-book-modal">
      <div class="modal-header">
        <h4 class="modal-title p-1" id="modal-basic-title">Sierra Recommended Alternates</h4>
        <button type="button" class="close btn btn-warning modal-close p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true" class="modal-crose">×</span>
        </button>
      </div>
      <div class="modal-body pt-0">
          <app-search-assist></app-search-assist>
      </div>
      <div class="modal-footer text-center" style="display: block;">
        <button type="button" class="btn btn-custom btn-warning px-xxl-5 btn-danger btn-red-custom" (click)="modal.close('cancel click')"><b>Cancel</b></button>
        <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="selectedSierraSuggItems()"><b>Replace selected parts with Sierra Recommended Alternates</b></button>
      </div>
  </ng-template>
<!-- LEVEL 1 ISSUES CHECK MODAL -->
  <ng-template #levelOneIssueModal let-modal class="address-book-modal">
    <div class="modal-header">
      <h4 class="modal-title p-1" id="modal-basic-title">BOM Item Issue Handling</h4>
    </div>
    <div class="modal-body pt-0">
      <div class="col-12 mt-5" *ngIf="selectedDniItem">
        <div class="col-12 mb-3 justify-content-center" id="levelOneIssueCheckSec">
            <div class="col-sm-12">
                <div class="table-responsive" id="levelOneIssueCheckTable">
                    <table width="100%" border="0" cellspacing="0" cellpadding="0" id="Quote-items-to-purchase" class="table table-bordered">
                        <thead>
                            <tr>
                                <th style="width: 2%;" align="center" valign="middle">ITEM#</th>
                                <th style="width: 8%;" align="center" valign="middle">MANUFACTURER PART NUMBER</th>
                                <th style="width: 8%;" align="center" valign="middle">REFERENCE DESIGNATORS</th>
                                <th style="width: 8%;" align="center" valign="middle">QUANTITY</th>
                                <th style="width: 18%;" align="center" valign="middle"> ISSUES FOUND </th>
                            </tr>
                        </thead>
                        <tbody id="display-tbody-issues">
                          <tr>
                            <td align="center" valign="top">{{selectedDniItem.itemNumber}}</td>
                            <td align="center" valign="top" style="width: 200px;"><input class="form-control" type="text" id="dniIssueItemMpn" [(ngModel)]="selectedDniItem.mpn" placeholder="" /></td>
                            <td align="center" valign="top" style="width: 150px;"><input class="form-control" type="text" id="dniIssueItemRef" [(ngModel)]="selectedDniItem.refdesc" placeholder="" /></td>
                            <td align="center" valign="top" style="width: 100px;"><input class="form-control" type="text" id="dniIssueItemQty" [(ngModel)]="selectedDniItem.qty" placeholder="" /></td>
                            <td align="left" valign="top" *ngIf="selectedDniItem.errors">
                              <ul style="text-align: left;">
                                <li *ngFor="let issuesObj of selectedDniItem.errors; let in = index" class="text-danger">{{issuesObj}}</li>
                              </ul>
                            </td>
                            <td *ngIf="!selectedDniItem.errors" align="center" valign="top">None</td>
                          </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    </div>
    <div class="modal-footer text-center" style="display: block;">
      <div class="fw-bold text-danger mb-2" id="errorMsg"> </div>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5 btn-danger btn-red-custom" (click)="onCancel(selectedDniItem.itemNumber)"><b>Cancel</b></button>
      <button type="button" class="btn btn-custom btn-warning px-xxl-5" (click)="dniItemIssueModalContinue(selectedDniItem)"><b>Continue</b></button>
      <div class="fw-bold text-success" *ngIf="!selectedDniItem.errors">All issues are resolved, Please wait while we move the component based on action selected</div>
    </div>
</ng-template>
</section>
